import { asyncLoad } from '@util'

export default {
  path: 'staff',
  components: asyncLoad(() => import('@components/Manage/Staff')),
  indexRoute: {
    component: asyncLoad(() => import('@components/Manage/Staff/List'))
  },
  stat: '购买记录',
  childRoutes: [
    {
      path: 'audit',
      components: asyncLoad(() => import('@components/Manage/Staff/Audit'))
    }
  ]
}
